import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';
import { IPlanosSales } from '../interfaces/planos_sales.interface';
import { IPlanos } from '../interfaces/planos.interface';
import { IQuantidadeDiarias } from '../interfaces/quantidade_diarias.interface';
import { Planos } from '../viewModel/planos.model';
import {
    BASICO,
    BASICO_TRIPLO,
    BLACK,
    BLACK_TRIPLO,
    COMPLETO,
    COMPLETO_TRIPLO,
    COUNT_DIARIAS_DEFAULT,
    EXCLUSIVO,
    EXCLUSIVO_TRIPLO,
    IDEAL,
    IDEAL_TRIPLO,
    PLUS,
    PLUS_TRIPLO, PRODUCTS,
    REQUINTE,
    REQUINTE_TRIPLO
} from '../../app.constants';
import {
    BASICO_TEXT,
    BASICO_TEXT_1,
    BASICO_TEXT_2,
    BLACK_TEXT,
    BLACK_TEXT_1,
    BLACK_TEXT_2,
    COMPLETO_TEXT,
    COMPLETO_TEXT_1,
    COMPLETO_TEXT_2,
    EXCLUSIVO_TEXT,
    EXCLUSIVO_TEXT_1,
    EXCLUSIVO_TEXT_2,
    IDEAL_TEXT,
    IDEAL_TEXT_1,
    IDEAL_TEXT_2,
    PLUS_TEXT,
    PLUS_TEXT_1,
    PLUS_TEXT_2,
    REQUINTE_TEXT,
    REQUINTE_TEXT_1,
    REQUINTE_TEXT_2
} from '../constants/planos_text.constant';
import { PLANS_INFORMATIONS } from '../constants/plans_informations.constant';
import { IPlan } from '../interfaces/plans-informations.interface';

@Injectable({ providedIn: 'root' })
export class ProdutoService extends BaseService {

    private minDaily = COUNT_DIARIAS_DEFAULT;
    constructor(private httpClient: HttpClient) {
        super(httpClient);
    }

    priceInformationCalculateLocal(price: IPlan['prices'][0]) {
        return price;
    }
    public priceInformation(price: IPlan['prices'][0], plan?: IPlanos) {
        if(!plan) {
            return this.priceInformationCalculateLocal(price);
        }
        const numberOfDailyDays = plan.qtdDiarias.filter(item => item.quantidadeDiarias === price.daily)[0];
        if(!numberOfDailyDays) {
            return this.priceInformationCalculateLocal(price);
        }
        price.price = numberOfDailyDays.valor;
        return price;
    }
    public async plansInformations(allFlag = false): Promise<ResultApi>  {
        // const plans = await this.planos() || [];
        // const plans =  [];
        const data: Array<IPlan> = PLANS_INFORMATIONS.map(item => {
            if(allFlag) {
                item.flag = 'SUPER FLAG';
            }
            // item.prices = item.prices.map(price => {
                // const plan = plans.filter(plan => plan.codigoCategoria === price.categoryCode)[0];
                // return this.priceInformation(price, plan);
                // return price;
            // })
            return item;
        });
        return new ResultApi().toResult({ status: 200, data, error: null });

    }

    public async produto(reload = false): Promise<ResultApi> {
        const httpOptions = {};
        // if (this.hasSalesToken()) {
            return this.httpClient
                .get<IPlanosSales>(`${this.salesUrl}/produtos/${this.idPriceBook}`, httpOptions)
                .toPromise()
                .then((res: any) => {
                    if (res) {
                        return new ResultApi().toResult({status: 202,  data: res, error: null});
                    }
                }).catch(async (err: any) => {
                    if (!reload) {
                        return await this.produto(true);
                    }
                    return new ResultApi().toResult({ status: 500, data: null, error: err});
                    // return new ResultApi().toResult({ status: 202, data: PRODUCTS, error: null});
                });
        // }
    }

    public async planos() {
        try {
            const result =  await this.produto();
            const data = !result ? [] : result.data;
            return this.setPlanos(data, false, ['COMPLETO', 'IDEAL', 'REQUINTE']);
        } catch (err) {
            return null;
        }
    }

    public async plans() {
        try {
            const result =  await this.planos();
            const data = !result ? [] : result;
            return this.setPlans(data);
        } catch (e) {
            return null;
        }
    }

    private setPlans(data: Array<IPlanos>) {
        try {
            return data.map(item => {
                return {
                    unitPrice: item.precoUnitario,
                    description: item.descricao,
                    categoryCode: item.codigoCategoria,
                    salesCategoryCode: item.codigoCategoriaSales,
                    numberOfDays: item.qtdDiarias.map(qtd => {
                        return {
                            price: qtd.valor,
                            description: qtd.descricao,
                            numberOfDays: qtd.quantidadeDiarias,
                            categoryCode: item.codigoCategoria,
                            salesCategoryCode: item.codigoCategoriaSales,
                            categoryDescription: item.descricao,
                        }
                    }),
                };
            })
        } catch (err) {
            return null;
        }

    }
    private setPlanos(data: IPlanosSales[], all: boolean = true, plans: Array<string> = []) {
        try {
            const planos: IPlanos[] = [];
            data.forEach(sales => {
                if (
                    sales.Product2.Name !== 'Taxa de Adesão' &&
                    sales.Product2.Name !== 'Taxa de Adesăo' &&
                    sales.Product2.Name !== 'Básico Duplo' &&
                    sales.Product2.Name !== 'Básico Triplo'
                ) {
                    const name = sales.Product2.Name;
                    const unitPrice = sales.UnitPrice;
                    const categoryCode = this.getCodigoCategoria(name);
                    const precoUnitario = sales.Preco_de_Lista_Mensal__c;
                    const plano: IPlanos = {
                        codigoCategoria: categoryCode,
                        descricao: (name === '') ? this.getPlanoPorCodigoCategoria(categoryCode) : name,
                        qtdDiarias: this.setNumberOfDays(name, categoryCode, unitPrice),
                        precoUnitario,
                        codigoCategoriaSales: sales.Product2Id
                    };
                    planos.push(plano);
                }
            });
            const result = planos.sort((a, b) => a.precoUnitario < b.precoUnitario ? -1 : a.precoUnitario < b.precoUnitario ? 1 : 0);
            return all ? result : result.filter(item => plans.includes(item.descricao.toUpperCase().split(' ')[0]));
        } catch (err) {
            return null;
        }
    }


    private getCodigoCategoria(name: string) {
        let result = '';
        switch (name) {
            case 'Básico Duplo': {
                result = '05';
                break;
            }
            case 'Básico Triplo': {
                result = '80';
                break;
            }
            case 'Completo Duplo': {
                result = '08';
                break;
            }
            case 'Completo Triplo': {
                result = '83';
                break;
            }
            case 'Ideal Duplo': {
                result = '11';
                break;
            }
            case 'Ideal Triplo': {
                result = '86';
                break;
            }
            case 'Exclusivo Duplo': {
                result = '14';
                break;
            }
            case 'Exclusivo Triplo': {
                result = '89';
                break;
            }
            case 'Requinte Duplo': {
                result = '17';
                break;
            }
            case 'Requinte Triplo': {
                result = '92';
                break;
            }
            case 'Plus Duplo': {
                result = '28';
                break;
            }
            case 'Plus Triplo': {
                result = '95';
                break;
            }
            case 'Black Duplo': {
                result = '31';
                break;
            }
            case 'Black Triplo': {
                result = '98';
                break;
            }
            default: {
                result = '0';
                break;
            }
        }
        return result;
    }

    private setNumberOfDays(name: string, categoryCode: string, unitPrice: number) {
        try {
            const numberOfDays: IQuantidadeDiarias[] = [];
            for(let daily = this.minDaily; daily <= 28; daily++) {
                const value = Number((daily * unitPrice / 12).toFixed(2));
                const amountOfDaily: IQuantidadeDiarias = {
                    categoriaDescricao: name,
                    codigoCategoria: categoryCode,
                    descricao: daily + ' diárias - 12 mensalidades de R$ ' + value,
                    quantidadeDiarias: daily,
                    valor: value
                };
                numberOfDays.push(amountOfDaily);
            }
            return numberOfDays;
        } catch (err) {
            return null;
        }
    }


    getPlanoPorCodigoCategoria(codigoCategoria: string) {
        let result = '';
        switch (codigoCategoria) {
            case '05': {
                result = 'Básico Duplo';
                break;
            }
            case '80': {
                result = 'Básico Triplo';
                break;
            }
            case '08': {
                result = 'Completo Duplo';
                break;
            }
            case '83': {
                result = 'Completo Triplo';
                break;
            }
            case '11': {
                result = 'Ideal Duplo';
                break;
            }
            case '86': {
                result = 'Ideal Triplo';
                break;
            }
            case '14': {
                result = 'Exclusivo Duplo';
                break;
            }
            case '89': {
                result = 'Exclusivo Triplo';
                break;
            }
            case '17': {
                result = 'Requinte Duplo';
                break;
            }
            case '92': {
                result = 'Requinte Triplo';
                break;
            }
            case '28': {
                result = 'Plus Duplo';
                break;
            }
            case '95': {
                result = 'Plus Triplo';
                break;
            }
            case '31': {
                result = 'Black Duplo';
                break;
            }
            case '98': {
                result = 'Black Triplo';
                break;
            }
            default: {
                result = '0';
                break;
            }
        }
        return result;
    }

    // TODO BEGIN MIXIN
    public cleanDescriptionDouble(plano: string) {
        try {
            plano = plano.toLowerCase();
            return plano.replace('duplo', '').toLowerCase();
        } catch (err) {
            return null;
        }
    }
    public cleanDescriptionTriple(plano: string) {
        try {
            plano = plano.toLowerCase();
            return plano.replace('triplo', '').toLowerCase();
        } catch (err) {
            return null;
        }
    }
    private adjustDescription(planos: Planos[]) {
        try {
            planos.map((plano) => {
                const desc = plano.descricao.toLowerCase();
                if (desc !== null) {
                    plano.descricao = desc.charAt(0).toUpperCase() + desc.slice(1);
                    if (plano.descricao.trim() === 'Basico') {
                        plano.descricao = 'Básico';
                    }
                }
            });
            return planos;
        } catch (err) {
            return null;
        }
    }
    private minDiary(planos: Planos[], min: number) {
        try {
            planos.forEach((value => {
                if (value.descricao === 'Básico') {
                    value.qtdDiarias = value.qtdDiarias.filter(v => v.quantidadeDiarias >= 7);
                    return;
                }
                value.qtdDiarias = value.qtdDiarias.filter(v => v.quantidadeDiarias >= min);
            }));
            return planos;
        } catch (err) {
            return null;
        }
    }
    public onlyDoubles(planos: Planos[], min: number = 7) {
        try {
            planos = planos.filter(value => {
                return (
                    value.codigoCategoria !== BASICO_TRIPLO    &&
                    value.codigoCategoria !== COMPLETO_TRIPLO  &&
                    value.codigoCategoria !== IDEAL_TRIPLO     &&
                    value.codigoCategoria !== EXCLUSIVO_TRIPLO &&
                    value.codigoCategoria !== REQUINTE_TRIPLO  &&
                    value.codigoCategoria !== PLUS_TRIPLO      &&
                    value.codigoCategoria !== BLACK_TRIPLO
                );
            });
            planos.forEach(value => value.descricao = this.cleanDescriptionDouble(value.descricao.toLowerCase()));
            planos = this.adjustDescription(planos);
            return this.minDiary(planos, min);
        } catch (err) {
            return null;
        }
    }
    public onlyTriples(planos: Planos[], min: number = 7) {
        try {
            planos = planos.filter(value => {
                return (
                    value.codigoCategoria !== BASICO    &&
                    value.codigoCategoria !== COMPLETO  &&
                    value.codigoCategoria !== IDEAL     &&
                    value.codigoCategoria !== EXCLUSIVO &&
                    value.codigoCategoria !== REQUINTE  &&
                    value.codigoCategoria !== PLUS      &&
                    value.codigoCategoria !== BLACK
                );
            });
            planos.forEach(value => value.descricao = this.cleanDescriptionTriple(value.descricao.toLowerCase()));
            planos = this.adjustDescription(planos);
            return this.minDiary(planos, min);
        } catch (err) {
            return null;
        }
    }
    public transitionType(selectedCategoria: string) {
        let result;
        switch (selectedCategoria) {
            case BASICO : {
                result = BASICO_TRIPLO;
                break;
            }
            case BASICO_TRIPLO : {
                result = BASICO;
                break;
            }
            case COMPLETO : {
                result = COMPLETO_TRIPLO;
                break;
            }
            case COMPLETO_TRIPLO : {
                result = COMPLETO;
                break;
            }
            case IDEAL : {
                result = IDEAL_TRIPLO;
                break;
            }
            case IDEAL_TRIPLO : {
                result = IDEAL;
                break;
            }
            case EXCLUSIVO: {
                result = EXCLUSIVO_TRIPLO;
                break;
            }
            case EXCLUSIVO_TRIPLO : {
                result = EXCLUSIVO;
                break;
            }
            case REQUINTE: {
                result = REQUINTE_TRIPLO;
                break;
            }
            case REQUINTE_TRIPLO : {
                result = REQUINTE;
                break;
            }
            case PLUS: {
                result = PLUS_TRIPLO;
                break;
            }
            case PLUS_TRIPLO : {
                result = PLUS;
                break;
            }
            case BLACK: {
                result = BLACK_TRIPLO;
                break;
            }
            case BLACK_TRIPLO : {
                result = BLACK;
                break;
            }
            default: {
                result = selectedCategoria;
                break;
            }
        }
        return result;
    }
    public monthlyValueString(descricao: string) {
        let valor = descricao.split('R$')[1];
        valor = valor.replace('.', ',');
        valor = valor.replace('*', '');
        return 'R$ ' + valor;
    }
    public getText(textType: number = 0, codigoCategoria: string, valor: string = '') {
        let text;
        switch (codigoCategoria) {
            case BASICO :
            case BASICO_TRIPLO : {
                text = textType === 1 ? BASICO_TEXT_1 : this.getTextWithPrice(BASICO_TEXT_2, valor);
                if (textType === 0) {
                    text = BASICO_TEXT;
                }
                break;
            }
            case COMPLETO :
            case COMPLETO_TRIPLO : {
                text = textType === 1 ? COMPLETO_TEXT_1 : this.getTextWithPrice(COMPLETO_TEXT_2, valor);
                if (textType === 0) {
                    text = COMPLETO_TEXT;
                }
                break;
            }
            case IDEAL :
            case IDEAL_TRIPLO : {
                text = textType === 1 ? IDEAL_TEXT_1 : this.getTextWithPrice(IDEAL_TEXT_2, valor);
                if (textType === 0) {
                    text = IDEAL_TEXT;
                }
                break;
            }
            case EXCLUSIVO:
            case EXCLUSIVO_TRIPLO : {
                text = textType === 1 ? EXCLUSIVO_TEXT_1 : this.getTextWithPrice(EXCLUSIVO_TEXT_2, valor);
                if (textType === 0) {
                    text = EXCLUSIVO_TEXT;
                }
                break;
            }
            case REQUINTE:
            case REQUINTE_TRIPLO : {
                text = textType === 1 ? REQUINTE_TEXT_1 : this.getTextWithPrice(REQUINTE_TEXT_2, valor);
                if (textType === 0) {
                    text = REQUINTE_TEXT;
                }
                break;
            }
            case PLUS:
            case PLUS_TRIPLO : {
                text = textType === 1 ? PLUS_TEXT_1 : this.getTextWithPrice(PLUS_TEXT_2, valor);
                if (textType === 0) {
                    text = PLUS_TEXT;
                }
                break;
            }
            case BLACK:
            case BLACK_TRIPLO : {
                text = textType === 1 ? BLACK_TEXT_1 : this.getTextWithPrice(BLACK_TEXT_2, valor);
                if (textType === 0) {
                    text = BLACK_TEXT;
                }
                break;
            }
            default: {
                text = '';
                break;
            }
        }
        return text;
    }
    private getTextWithPrice(text: string, valor: string) {
        text = text.replace('R$ 000,00', valor);
        return text;
    }
    // TODO END MIXIN
}
